/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable @typescript-eslint/no-misused-promises */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState, useEffect } from "react";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
  Button,
  Card,
  CardContent,
  CardDescription,
  CardTitle,
  Combobox,
  DatePicker,
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
  Input,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Textarea,
} from "@repo/ui";
import { zodResolver } from "@hookform/resolvers/zod";
import type { UseFormReturn } from "react-hook-form";
import { useForm } from "react-hook-form";
import { z } from "zod";
import { format } from "date-fns";
import { Link, useNavigate } from "react-router-dom";
import { PREV_5_DAY_DATE } from "utils/constant";
import { useGetRoutes, useAutocompleteCDMs } from "utils/apis/lookups.api";
import Layout from "components/layout";
import { useCreateClearanceRequest } from "utils/apis/clearance.api";
import SearchableDropdown from "components/searchableDropdown";

// -------------------- extracted constants --------------------
const JOB_PRIORITIES = [
  { value: "1", name: "Critical" },
  { value: "2", name: "High" },
  { value: "3", name: "Normal" },
  { value: "4", name: "Low" },
];

const JOB_NATURES = [
  { value: "Normal", name: "Normal" },
  { value: "Adhoc", name: "Adhoc" },
  { value: "Special Service", name: "Special Service" },
];

// const JOB_TYPES = [
//   { value: "Cassette Swap", name: "Cassette Swap" },
//   { value: "Bag Replacement", name: "Bag Replacement" },
// ];

const INVOICING_MODELS = [
  { value: "Fixed", name: "Fixed" },
  { value: "Dedicated", name: "Dedicated" },
  { value: "Service", name: "Service" },
];

// -------------------- form schema --------------------
const formSchema = z.object({
  customerId: z.string().min(1, { message: "Customer is required." }),
  servicePointId: z.string().min(1, { message: "Location is required." }),
  requestedBy: z.string().min(1, { message: "Requested By is required." }),
  source: z.string().optional(),
  serviceDateTime: z.date({ required_error: "Service date is required." }),
  invoicingModel: z.string(),
  priority: z.string().min(1, { message: "Job Priority is required." }),
  jobNature: z.string(),
  jobType: z.string().min(1, { message: "Job Type is required." }),
  shift: z.string().min(1, { message: "Shift is required." }),
  routeNo: z.string().optional(),
  remarks: z.string().optional(),
  customerName: z.string().optional(),
});

// -------------------- helpers --------------------
function buildPayload(values: any) {
  const currentDate = new Date();
  const svcDate = new Date(values.serviceDateTime);
  svcDate.setHours(
    currentDate.getHours(),
    currentDate.getMinutes(),
    currentDate.getSeconds(),
    currentDate.getMilliseconds(),
  );
  const formatted = format(svcDate, "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'");

  const payload = { ...values, serviceDateTime: formatted };
  return payload;
}

// -------------------- main component --------------------
export default function CreateClearance() {
  const navigate = useNavigate();

  const [sourceLocation, setSourceLocation] = useState<any>(null);
  const [searchTerm, setSearchTerm] = useState("");

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      servicePointId: "",
      invoicingModel: "Service",
      jobNature: "Normal",
      priority: "2",
      shift: "morning",
      jobType: "Clearance",
      serviceDateTime: new Date(),
      routeNo: "",
      remarks: "",
      customerId: "",
      customerName: "",
      requestedBy: "",
    },
  });

  const { data: inRouteTeams } = useGetRoutes();

  // mutations
  const {
    mutate: createRequest,
    isSuccess: isRequestSuccess,
    isPending: isRequestPending,
    isError: isRequestError,
    reset: requestReset,
  } = useCreateClearanceRequest();

  const { data: autocompleteResults, isFetching: isFetchingAutocomplete } =
    useAutocompleteCDMs(searchTerm);
  const mappedLocations =
    autocompleteResults?.map((item: any) => ({
      value: item.servicePointId,
      label: `${item.barcode || ""}-${item.locationId}`,
      // barcode: item.barcode || "",
    })) || [];

  const onSourceLocationChanged = (value: string) => {
    form.setValue("servicePointId", value);
    setSourceLocation(null);

    const selected = autocompleteResults?.find(
      (atm: any) => String(atm.servicePointId) === String(value),
    );
    setSourceLocation(selected);
    form.setValue("customerId", selected?.customerId);
    form.setValue("customerName", selected?.customer);
  };

  useEffect(() => {
    if (isRequestSuccess) {
      navigate(-1);
      form.reset();
      requestReset();
      setSourceLocation(null);
      setSearchTerm("");
    }
    if (isRequestError) {
      requestReset();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRequestSuccess, isRequestError]);

  function onSubmit(values: z.infer<typeof formSchema>) {
    const payload = buildPayload(values);
    createRequest(payload);
  }

  return (
    <Layout>
      <Breadcrumb className="mt-5 mx-4">
        <BreadcrumbList>
          <BreadcrumbItem>
            <Link to="/dashboard">Home</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <Link to="/clearance">Clearance</Link>
          </BreadcrumbItem>
          <BreadcrumbSeparator />
          <BreadcrumbItem>
            <BreadcrumbPage>Create Clearance Request</BreadcrumbPage>
          </BreadcrumbItem>
        </BreadcrumbList>
      </Breadcrumb>

      <div className="flex mx-4 mt-5 gap-3">
        <Card className="flex-1">
          <CardContent className="pt-6">
            <CardDescription>
              <Form {...form}>
                <form
                  id="collection-form"
                  onSubmit={form.handleSubmit(onSubmit)}
                  className="gap-4 grid grid-cols-2"
                >
                  <FormField
                    control={form.control}
                    name="servicePointId"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Location</FormLabel>

                        <SearchableDropdown
                          value={field.value}
                          searchTerm={searchTerm}
                          onSearchChange={setSearchTerm}
                          data={mappedLocations}
                          loading={isFetchingAutocomplete}
                          onChange={(val) => {
                            field.onChange(val);
                            onSourceLocationChanged(val);
                          }}
                        />

                        <FormMessage />
                      </FormItem>
                    )}
                  />
                  <FormField
                    control={form.control}
                    name="customerName"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Customer</FormLabel>
                        <FormControl>
                          <Input readOnly {...field} />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />

                  <FormField
                    control={form.control}
                    name="serviceDateTime"
                    render={({ field }) => (
                      <FormItem className="space-y-2">
                        <FormLabel>Service Date</FormLabel>
                        <DatePicker
                          {...field}
                          placeholder="Pick a date"
                          selectedDate={field.value}
                          onSelectDate={field.onChange}
                          disabled={(date) => date < PREV_5_DAY_DATE}
                        />
                        <FormMessage />
                      </FormItem>
                    )}
                  />

                  <FormSelect
                    form={form}
                    data={INVOICING_MODELS}
                    name="invoicingModel"
                    label="Invoicing Model"
                    placeholder="Select Invoicing Model"
                  />
                  <FormSelect
                    form={form}
                    data={JOB_PRIORITIES}
                    name="priority"
                    label="Job Priority"
                    placeholder="Select Job Priority"
                  />
                  <FormSelect
                    form={form}
                    data={JOB_NATURES}
                    name="jobNature"
                    label="Job Nature"
                    placeholder="Select Job Nature"
                  />

                  <FormCombobox
                    form={form}
                    data={inRouteTeams?.map((m: any) => ({
                      value: String(m.routeNo),
                      label: `${m.routeNo} (${m.description})`,
                    }))}
                    name="routeNo"
                    label="Route"
                    placeholder="Select Route"
                  />

                  <FormField
                    control={form.control}
                    name="requestedBy"
                    render={({ field }) => (
                      <FormItem>
                        <FormLabel>Requested By</FormLabel>
                        <FormControl>
                          <Input
                            type="text"
                            placeholder="Select Requested By"
                            {...field}
                          />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                  <FormField
                    control={form.control}
                    name="remarks"
                    render={({ field }) => (
                      <FormItem className="col-span-2">
                        <FormLabel>Remarks</FormLabel>
                        <FormControl>
                          <Textarea
                            placeholder="Write your remarks"
                            className="resize-none"
                            {...field}
                          />
                        </FormControl>
                        <FormMessage />
                      </FormItem>
                    )}
                  />
                </form>
              </Form>
            </CardDescription>
          </CardContent>
        </Card>

        <Card className="flex-1">
          <CardContent className="pt-6">
            <CardTitle className="text-lg">Request Review</CardTitle>
            <CardDescription className="mt-4">
              <h5 className="text-md font-bold">Source Location</h5>
              <div className="mt-2 grid grid-cols-3 gap-3">
                <div>
                  <label>Location ID</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.locationId || ""}
                  </div>
                </div>
                <div>
                  <label>Location Name</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.locationName || ""}
                  </div>
                </div>
                <div>
                  <label>Machine Type</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.machineType || ""}
                  </div>
                </div>
                <div>
                  <label>Maker</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.maker || ""}
                  </div>
                </div>
                <div>
                  <label>Model</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.model || ""}
                  </div>
                </div>
                <div>
                  <label>Route No</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.routeNo || ""}
                  </div>
                </div>
                <div>
                  <label>Site Limit</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.siteLimit || ""}
                  </div>
                </div>
                <div>
                  <label>Service Days</label>
                  <div className="border border-input mt-1 rounded-md p-2 min-h-9">
                    {sourceLocation?.serviceDays || ""}
                  </div>
                </div>
              </div>

              <hr className="border-b bg-accent my-4" />

              <Button
                type="submit"
                form="collection-form"
                disabled={isRequestPending}
                isLoading={isRequestPending}
                variant="secondary"
                className="w-full mt-5"
              >
                Submit
              </Button>
            </CardDescription>
          </CardContent>
        </Card>
      </div>
    </Layout>
  );
}

function FormSelect({
  form,
  name,
  label,
  placeholder,
  data,
  onChange,
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder?: string;
  data?: { name: string; value: any }[];
  onChange?: (e: any) => void;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Select
            onValueChange={(e) => {
              field.onChange(e);
              onChange?.(e);
            }}
            value={field.value as any}
          >
            <FormControl>
              <SelectTrigger>
                <SelectValue placeholder={placeholder} />
              </SelectTrigger>
            </FormControl>
            <SelectContent>
              {data?.map((item) => (
                <SelectItem key={item.value} value={item.value}>
                  {item.name}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}

function FormCombobox({
  form,
  name,
  label,
  placeholder,
  data,
  onChange,
  disabled,
  ...props
}: {
  form: UseFormReturn<z.infer<typeof formSchema>>;
  name: keyof z.infer<typeof formSchema>;
  label: string;
  placeholder: string;
  data?: { label: string; value: any }[];
  disabled?: boolean;
  onChange?: (e: any) => void;
}) {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem>
          <FormLabel>{label}</FormLabel>
          <Combobox
            value={field.value as any}
            setValue={(e: string) => {
              field.onChange(e);
              onChange?.(e);
            }}
            data={data}
            placeholder={placeholder}
            disabled={disabled}
            {...props}
          />
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
